import '@operato/dataset/ox-data-summary-view.js'

import gql from 'graphql-tag'
import { css, html, LitElement } from 'lit'
import { customElement, property, query, state } from 'lit/decorators.js'

import { client } from '@operato/graphql'
import { i18next, localize } from '@operato/i18n'
import { ScrollbarStyles } from '@operato/styles'
import { DataItem } from '@operato/dataset'

type DataSummary = {
  name: string
  description: string
  dataItems?: DataItem[]
  date?: string
  period?: string
  key01?: string
  key02?: string
  key03?: string
  key04?: string
  key05?: string
  count?: number
  countOoc?: number
  countOos?: number
  summary?: { [key: string]: any }
}

@customElement('data-summary-view')
class DataSummaryView extends localize(i18next)(LitElement) {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;

        background-color: var(--md-sys-color-surface);
      }

      div[content] {
        flex: 1;

        display: flex;
        overflow: auto;
      }

      ox-data-summary-view {
        flex: 1;
        padding: var(--spacing-large);
        overflow: auto;
      }
    `
  ]

  @property({
    type: String,
    attribute: 'data-summary-id'
  })
  dataSummaryId?: string

  @state() dataSummary?: DataSummary

  render() {
    return html`
      <div content>
        ${this.dataSummary
          ? html`<ox-data-summary-view .dataSummary=${this.dataSummary}></ox-data-summary-view>`
          : html``}
      </div>
    `
  }

  updated(changes) {
    if (changes.has('dataSummaryId')) {
      this.fetchDataSummary()
    }
  }

  async fetchDataSummary() {
    const id = this.dataSummaryId

    const response = await client.query({
      query: gql`
        query ($id: String!) {
          dataSummary(id: $id) {
            id
            name
            description
            dataSet {
              id
            }
            dataItems {
              name
              description
              active
              hidden
              tag
              group
              type
              unit
              options
              quota
              spec
              stat
            }
            date
            period
            key01
            key02
            key03
            key04
            key05
            summary
            count
            countOoc
            countOos
            updater {
              id
              name
            }
            updatedAt
          }
        }
      `,
      variables: {
        id
      }
    })

    this.dataSummary = response.data.dataSummary
  }
}
